{
  "alert": "警示",
  "dismiss": "關閉"
}